import DATATABLE_TRANSLATIONS from "./datatable_translations";
export default class FreeFormSmsDataTable {
  constructor() {
    $(document).ready(function() {
      showFreeFormSmsTable();
    });

    $(document).on("turbo:render", function() {
      showFreeFormSmsTable();
    });

    function showFreeFormSmsTable() {
      $('#free-form-sms-datatable').dataTable({
        "order": [[3, "desc"]],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#free-form-sms-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "sms_to"},
          {"data": "sms_text"},
          {"data": "status"},
          {"data": "created_at"}
        ]
      });
    }
  }
}
